import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import partner1 from '../../sources/Graph/partner1.png'
import partner2 from '../../sources/Graph/partner2.png'
import partner3 from '../../sources/Graph/partner3.png'
import partner4 from '../../sources/Graph/partner4.png'
import partner5 from '../../sources/Graph/partner5.png'
import partner6 from '../../sources/Graph/partner6.png'
import partner7 from '../../sources/Graph/partner7.png'
import partner8 from '../../sources/Graph/partner8.png'

function Features() {
  const { t } = useTranslation();

  const partners = [
    { img: partner1 },
    { img: partner2 },
    { img: partner3, scale: '80%' },
    { img: partner4, scale: '80%' },
    { img: partner5 },
    { img: partner6, scale: '70%' },
    { img: partner7 },
    { img: partner8 },
  ];
  

  return (
    <Box width="100%" align='center'>
      <Typography fontFamily="Noto Sans TC" textAlign="center" fontSize="36px" fontWeight={600} fontStyle="normal" color='#7DC4A2' py={3} sx={{ textShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)', lineHeight: '100%', position: 'relative'}}>
        {t('Partners.title')}
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {partners.map((partner, index) => (
          <Grid item key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box sx={{ 
              width: '347px', 
              height: '100px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              mb: 1
            }}>
              <img 
                src={partner.img}
                alt={`partner${index + 1}`}
                style={{ maxWidth: partner.scale || '100%', maxHeight: partner.scale || '100%', width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Features;